import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';

const StyledContainer = styled('div', {
  dynamic: ({ isOpen, offset, contentWidth }) => ({
    position: 'fixed',
    zIndex: 200,
    pointerEvents: 'none',
    top: offset,
    right: isOpen ? contentWidth : 0,
    '@media print': {
      display: 'none',
    },
  }),
});

const StyledContent = styled('div', {
  dynamic: ({ contentWidth, contentHeight }) => ({
    width: contentWidth,
    height: contentHeight,
    position: 'absolute',
    pointerEvents: 'auto',
    top: 0,
    left: '100%',
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 8px 2px',
    backgroundColor: '#fff',
  }),
});

const StyledButton = styled(Button, {
  dynamic: ({ backgroundColor, color }) => ({
    '&.abyss-button-root': {
      backgroundColor: backgroundColor
        ? `${backgroundColor} !important`
        : undefined,
      color: '$primary1',
      pointerEvents: 'auto',
      borderWidth: 1.25,
      borderRadius: '10px 10px 0 0',
      borderBottom: 'none',
      transform: 'rotate(-90deg) translate(0, -100%)',
      transformOrigin: '100% 0',
      height: 33,
      padding: '5px 15px 2px 10px !important',
    },
  }),
});

export const SideTab = ({
  children,
  isOpen,
  onClick,
  offset,
  contentWidth,
  content,
  variant,
  size,
  before,
  after,
  backgroundColor,
  color,
  ...props
}) => {
  const sideNavRef = useRef();
  const contentHeight = sideNavRef.current ? sideNavRef.current.clientWidth : 0;

  return (
    <StyledContainer
      isOpen={isOpen}
      offset={offset}
      contentWidth={contentWidth}
      ref={sideNavRef}
      {...props}
    >
      {isOpen && (
        <StyledContent
          contentWidth={contentWidth}
          contentHeight={contentHeight}
        >
          {content}
        </StyledContent>
      )}
      <StyledButton
        variant={variant}
        orientation='vertical'
        size={size}
        onClick={onClick}
        before={before}
        after={after}
        css={{
          '.abyss-insert-element-before': {
            paddingRight: '8px',
          },
          '.abyss-insert-element-after': {
            paddingLeft: '8px',
          },
        }}
      >
        {children}
      </StyledButton>
    </StyledContainer>
  );
};

SideTab.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  offset: PropTypes.number,
  contentWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  content: PropTypes.node,
  variant: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  before: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  after: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
};

SideTab.defaultProps = {
  children: null,
  isOpen: false,
  onClick: null,
  offset: 300,
  contentWidth: 300,
  content: null,
  variant: 'solid',
  size: 14,
  before: null,
  after: null,
  backgroundColor: null,
  color: null,
};
